import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import VentilatorEventsStore from "./VentilatorEventsStore";
import Loader from "../../shared/Loader/Loader";
import "./VentilatorEvents.scss";

class Ventilator extends Widget {
  constructor(props) {
    super(props);
    this.store = new VentilatorEventsStore();
  }
  render() {
    return (
      <div className="widget ventilator-events">
        {this.store.loading ? (
          <Loader />
        ) : (
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.store.events.alarms.map((alarm, i) => (
                <tr key={i}>
                  <td>{this.date(alarm.timestamp)}</td>
                  <td>{this.time(alarm.timestamp)}</td>
                  <td>{alarm.type}</td>
                  <td>{alarm.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default inject("store")(observer(Ventilator));
